import SubOptionRow from "./SubOptionRow.tsx";
import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';


const OptionRow = ({ option }: any) => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <TableRow>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }}>
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="left">{option.optionName}</TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center">
                    £{option.vatInAmount}
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center">
                    £{option.sdInAmount}
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center">
                    {option.qty}
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center">
                    £{option.basePrice}
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3", textWrap: 'nowrap' }} align="center">
                    £{option.basePrice * option.qty}
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f3f3f3" }} align="center">
                    £{option.totalPrice}
                </TableCell>
            </TableRow>
            {option?.subOptions?.length > 0 &&
                <TableRow >
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 1 }}>
                                <Typography variant="h6" gutterBottom>
                                    Sub options
                                </Typography>
                                <Table size="small" aria-label="food-items">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">Sub Option Name</TableCell>
                                            <TableCell align="center">VAT Per Sub Option</TableCell>
                                            <TableCell align="center">SD Per Sub Option</TableCell>
                                            <TableCell align="center">Sub Option Quantity</TableCell>
                                            <TableCell align="center">Sub Option Base Price</TableCell>
                                            <TableCell align="center">Sub Total</TableCell>
                                            <TableCell align="center">Sub Option Total Price</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {open && option?.subOptions?.length > 0 && option.subOptions.map((subOption, index) => (
                                            <SubOptionRow key={index} subOption={subOption} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow >
            }
        </>
    );
};

export default OptionRow;